import styled from "@emotion/styled";
export const QuickReactionsSpan = styled.span `
  display: inline-block;
  position: relative;

  box-sizing: border-box;
`;
